const getConfigFile = async (path) => {
  let result;

  try {
    result = await import("../config/" + path);
  } catch (e) {
    result = false;
  }

  return result;
};

export default getConfigFile;
